var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 10.3235H39.6667C39.9731 10.3235 40.2765 10.3829 40.5596 10.4982C40.8427 10.6134 41.0999 10.7824 41.3166 10.9955C41.5333 11.2085 41.7051 11.4614 41.8224 11.7397C41.9397 12.0181 42 12.3164 42 12.6177V36.7059C42 37.3143 41.7542 37.8978 41.3166 38.3281C40.879 38.7583 40.2855 39 39.6667 39H15.1667C14.5478 39 13.9543 38.7583 13.5168 38.328C13.0792 37.8978 12.8334 37.3143 12.8334 36.7059V32.1176H1.16665C1.01344 32.1176 0.86173 32.088 0.720182 32.0303C0.578634 31.9727 0.450022 31.8882 0.341687 31.7817C0.233353 31.6752 0.147419 31.5487 0.0887922 31.4095C0.0301653 31.2704 -6.24412e-06 31.1212 9.69287e-10 30.9706V1.14709C-6.24412e-06 0.996453 0.0301653 0.847292 0.0887922 0.708121C0.147419 0.56895 0.233353 0.442495 0.341687 0.335978C0.450022 0.22946 0.578634 0.144965 0.720182 0.087318C0.86173 0.0296708 1.01344 -1.2514e-10 1.16665 0H31.5C31.6532 -1.25139e-10 31.8049 0.0296708 31.9465 0.087318C32.088 0.144965 32.2166 0.22946 32.325 0.335978C32.4333 0.442495 32.5192 0.56895 32.5779 0.708121C32.6365 0.847292 32.6667 0.996453 32.6667 1.14709V10.3235ZM32.6667 12.6177V30.9706C32.6667 31.1212 32.6365 31.2704 32.5779 31.4095C32.5192 31.5487 32.4333 31.6752 32.325 31.7817C32.2166 31.8882 32.088 31.9727 31.9465 32.0303C31.8049 32.088 31.6532 32.1176 31.5 32.1176H15.1667V36.7059H39.6667V12.6177H32.6667ZM30.3334 10.3235V2.29413H2.33335V29.8235H30.3334V10.3235Z",
    fill: "#FF3029"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRCopy);
export default __webpack_public_path__ + "static/media/r-copy.c538f219f16fe2503c1505af80291d8c.svg";
export { ForwardRef as ReactComponent };